// extracted by mini-css-extract-plugin
module.exports = {"defaultButton":"styles_defaultButton__2ZKmU","borderedButton":"styles_borderedButton__zrdhR","buttonDisabled":"styles_buttonDisabled__hnoNj"};